import { Formik } from "formik";
import { Modal, Spinner } from "react-bootstrap";
import * as Yup from "yup";
import swal from "sweetalert";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { sendConsulationsMessageFunc } from "../../../store/Slices/consultations/SendConsulationsMessageSlicer";

const sednMessageValidation = Yup.object().shape({
  link: Yup.string()
    .required("Link is required"),
  date: Yup.string()
    .required("Date is required"),
  time: Yup.string()
    .required("Time is required")
});

export default function SendConsulationMessage({show , onHide , consId , reftechData}){
    const {loading:loading} = useSelector(
        state => state.sendConsulationsMessageSlicer
    )
    const dispatch = useDispatch();
    const colors = [
        '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff',
        '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff',
        '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff',
        '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2',
        '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466',
        '#000000', '#990000', '#b26b00', '#b2b200', '#005c00', '#003399', '#592966'
    ];
    const modules = {
        toolbar: {
        container: [
            [{"color" : colors}],
            [{ 'background': colors }]
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['link' , "video"],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['clean']
        ],
    }
    };
    const handleCloseForm = () => {
        onHide();
    }
    const handleFormSubmite = (value, { resetForm }) => {
        console.log(value)
        dispatch(sendConsulationsMessageFunc({data : value , consultationId : consId})).then((result) => {
          if (result.payload.message === "Email Sent Successfully") {
            swal("Good job!", result.payload.message, "success");
            resetForm();
            handleCloseForm();
            reftechData();
          }
        });
      };
    return (
        <>
            <Modal
            size="lg"
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            // keyboard={false}
            >
            <Modal.Body>
            <h4 className="card-title">Send Message</h4>
            <div className="basic-form">
                <Formik
                initialValues={{
                    link: '',
                    date: '',
                    time: '',
                }}
                validationSchema={sednMessageValidation}
                onSubmit={handleFormSubmite}
                >
                {({
                    values,
                    errors,
                    setFieldValue,
                    setValues,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    handleReset,
                }) => (
                    <form onSubmit={handleSubmit}>
                    <div className="row">
                        {/* subject  */}
                        <div
                        className={`col-12 form-group mb-3 ${
                            values.link
                            ? errors.link
                                ? "is-invalid"
                                : "is-valid"
                            : ""
                        }`}
                        >
                        <label className="text-label">
                            Link
                        </label>
                        <div className="input-group">
                            <span className="input-group-text">
                            <i className="fa fa-user" />
                            </span>
                            <input
                            type="url"
                            className="form-control"
                            placeholder="Enter a link.."
                            name="link"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.link}
                            />
                            <div
                            id="val-link-error"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                            >
                            {errors.link && errors.link}
                            </div>
                        </div>
                        </div>
                        <div
                        className={`col-12 form-group mb-3 ${
                            values.date
                            ? errors.date
                                ? "is-invalid"
                                : "is-valid"
                            : ""
                        }`}
                        >
                            <label className="text-label">
                                Date
                            </label>
                            <div className="input-group">
                                <span className="input-group-text">
                                <i className="fa fa-user" />
                                </span>
                                <input
                                type="date"
                                className="form-control"
                                // placeholder="Enter a name.."
                                name="date"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.date}
                                />
                                <div
                                id="val-date-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                                >
                                {errors.date && errors.date}
                                </div>
                                </div>
                            {/* <div
                            id="val-arname-error"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                            >
                            {errors.message && errors.message}
                            </div>
                            <ReactQuill 
                            modules = {modules}
                            onBlur={handleBlur}
                            value={values.message}
                            className="p-0 border-none outline-none form-control bg-white mt-3" 
                            // value={productDesc} 
                            placeholder="Enter a Message.."
                            theme="snow" 
                            onChange={(content) => setFieldValue('message', content)} 
                            /> */}
                        </div>
                        <div
                        className={`col-12 form-group mb-3 ${
                            values.time
                            ? errors.time
                                ? "is-invalid"
                                : "is-valid"
                            : ""
                        }`}
                        >
                            <label className="text-label">
                                Time
                            </label>
                            <div className="input-group">
                                <span className="input-group-text">
                                <i className="fa fa-user" />
                                </span>
                                <input
                                type="time"
                                className="form-control"
                                // placeholder="Enter a name.."
                                name="time"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.time}
                                />
                                <div
                                id="val-time-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                                >
                                {errors.time && errors.time}
                                </div>
                                </div>
                            {/* <div
                            id="val-arname-error"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                            >
                            {errors.message && errors.message}
                            </div>
                            <ReactQuill 
                            modules = {modules}
                            onBlur={handleBlur}
                            value={values.message}
                            className="p-0 border-none outline-none form-control bg-white mt-3" 
                            // value={productDesc} 
                            placeholder="Enter a Message.."
                            theme="snow" 
                            onChange={(content) => setFieldValue('message', content)} 
                            /> */}
                        </div>
                    </div>
                    {loading ? (
                        <>
                        <button
                            className="btn me-2 btn-primary"
                            disabled
                        >
                            <Spinner
                            variant="primary"
                            animation="border"
                            />
                        </button>
                        </>
                    ) : (
                        <>
                        <button
                            type="submit"
                            className="btn me-2 btn-primary"
                        >
                            Send
                        </button>
                        </>
                    )}

                    <button
                        className="btn me-2 btn-danger"
                        onClick={handleCloseForm}
                    >
                        Close
                    </button>
                    </form>
                )}
                </Formik>
            </div>
            </Modal.Body>
            </Modal>
        </>
    )
}